module.exports = __webpack_public_path__ + "static/img/RGH-Sectors-SecondShip.3c62705.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medias/images/Sectors/RGH-Sectors-SecondShip.jpg
// module id = mbXm
// module chunks = 1